import React, { useEffect } from "react";
import { Box } from "@mui/material";
import FounderPresentation from "../components/AboutUs/FounderPresentation";
import BrandsPresentation from "../components/AboutUs/BrandsPresentation";

const CorporalStetic = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box component="main">
      <FounderPresentation />
      <BrandsPresentation />
    </Box>
  );
};

export default CorporalStetic;